module.exports = __webpack_public_path__ + "images/tech-responsive-google-cloud.svg";